// Tiếng bíp đếm ngược, sinh bằng WebAudio — không cần file mp3 nào.
//
// ⚠️ Chính sách tự phát của trình duyệt: `AudioContext` chỉ chạy được nếu được
// tạo (hoặc đánh thức) TRONG một sự kiện do người dùng bấm. Vì vậy `primeAudio`
// phải được gọi ngay trong `onClick` của nút chụp, không phải trong `useEffect`.

let ctx = null;

export const primeAudio = () => {
    try {
        if (!ctx) {
            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            if (!AudioCtx) return;
            ctx = new AudioCtx();
        }
        // Trình duyệt có thể tạm ngưng context khi rời tab; đánh thức lại.
        if (ctx.state === "suspended") ctx.resume();
    } catch {
        ctx = null; // thiết bị không hỗ trợ — chạy im lặng, không làm sập gì
    }
};

const tone = (freq, ms, volume) => {
    if (!ctx || ctx.state !== "running") return;

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "sine";
    osc.frequency.value = freq;

    // Tắt dần theo hàm mũ nghe êm hơn nhiều so với cắt phụt — cắt đột ngột tạo
    // tiếng "tách" do dạng sóng đứt quãng.
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + ms / 1000);

    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + ms / 1000);
};

// Bíp ngắn cho mỗi giây đếm ngược.
export const beepTick = () => tone(880, 110, 0.1);

// Giây cuối cùng: cao hơn, dài hơn — báo "chuẩn bị".
export const beepLastTick = () => tone(1170, 160, 0.12);

// Tiếng màn trập lúc chụp.
export const beepShutter = () => tone(1560, 240, 0.14);
